export const companies = [
  "Bradesco",
  "Itaú",
  "Santander",
  "Safra",
  "Banco do Brasil",
  "Caixa",
  "BTG",
];

export const jobTitles = [
  "Operador de caixa",
  "Analista",
  "Supervisor/coordenador",
  "Gerente assistente",
  "Gerente comercial",
  "Gerente de contas",
  "Gerente administrativo",
  "Gerente de relacionamento",
  "Agente de negócios",
  "Especialista de investimentos",
  "Advogado",
  "Superintendente",
  "Cientista de dados",
];
